import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { boostSocialRoute } from '@features/boostMyJobs/api/constants';
import axiosInstance from '@server/axiosInstance';
import { paymentDetails } from '@features/payments';

type UseBoostSocialProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useBoostSocial = ({ setErrorText }: UseBoostSocialProps) => {
  const client = useQueryClient();

  const { mutate: boostSocial, isLoading: isBoostSocialLoading } = useMutation({
    mutationFn: (variables: {
      company_id: number | string | undefined;
      token?: string;
    }) =>
      axiosInstance.post(boostSocialRoute, variables).then((res) => res.data),

    onMutate: () => {
      setErrorText('');
    },

    onSuccess: (data) => {
      if (data.status === 200) {
        setErrorText('');
        client.invalidateQueries([paymentDetails]);
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { response?: { data?: { message?: string } } }) => {
      setErrorText(error?.response?.data?.message || errorMessage);
    },
  });

  return {
    boostSocial,
    isBoostSocialLoading,
  };
};
